import { modalController } from '@ionic/core';
import { RfiDoc } from 'common';

export class RfiEditModalController {
  static async present(projectId: string, rfi: RfiDoc): Promise<RfiDoc | null> {
    const modal = await modalController.create({
      component: 'rfi-edit-modal',
      componentProps: { original: rfi, projectId },
      backdropDismiss: false,
      cssClass: 'modal-height-auto',
    });
    return new Promise(async resolve => {
      modal.addEventListener('saved', (e: CustomEvent<RfiDoc>) => {
        modal.dismiss();
        resolve(e.detail);
      });
      modal.addEventListener('dismiss', () => {
        modal.dismiss();
        resolve(null);
      });
      await modal.present();
    });
  }
}
